module.exports = __webpack_public_path__ + "static/media/3.1eb75805.png";